import { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Container } from 'react-bootstrap';
import SpringBootC from "./../assets/certificates/spring_boot.png";
import CyberGen from "./../assets/certificates/cybegen.png";

const certificates = [
    {
        id: 1,
        title: "Spring Boot Certification",
        image: SpringBootC,
        issuer: "Udemy"
    },
    {
        id: 2,
        title: "Cybersecurity Certification",
        image: CyberGen,
        issuer: "CybGen"
    },
];

const Certificates = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    const startInterval = () => {
        intervalRef.current = setInterval(() => {
            if (!isHovered) {
                setCurrentIndex((prevIndex) =>
                    prevIndex === certificates.length - 1 ? 0 : prevIndex + 1
                );
            }
        }, 3000);
    };

    useEffect(() => {
        startInterval();
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [isHovered]);

    const handleMouseEnter = () => {
        setIsHovered(true);
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
        startInterval();
    };

    return (
        <Container fluid className="py-5" style={{
            background: '#0d1b2a',
            minHeight: '700px'
        }}>
            <h2 className="text-center text-white mb-4">My Certifications</h2>

            <div
                className="certificates-container"
                style={{
                    position: 'relative',
                    height: '550px',
                    overflow: 'hidden',
                    width: '100%',
                    margin: '0 auto',
                    maxWidth: '900px'
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {certificates.map((certificate, index) => (
                    <motion.div
                        key={certificate.id}
                        initial={{ x: '100%' }}
                        animate={{
                            x: index === currentIndex ? '0%' :
                                index < currentIndex ? '-100%' : '100%',
                            opacity: index === currentIndex ? 1 : 0.5,
                            scale: index === currentIndex ? 1 : 0.9
                        }}
                        transition={{ duration: 0.8, ease: 'easeInOut' }}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '20px'
                        }}
                    >
                        <div className="certificate-card text-center rounded" style={{
                            background: 'rgba(27, 38, 59, 0.8)',
                            border: '1px solid #778da9',
                            width: '100%',
                            maxWidth: '800px',
                            padding: '20px',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <div style={{ marginBottom: '15px' }}>
                                <h4 className="text-white mb-2">{certificate.title}</h4>
                                <p className="text-accent-blue mb-0">{certificate.issuer}</p>
                            </div>
                            <div className="certificate-image-container" style={{
                                flex: 1,
                                overflow: 'auto',
                                borderRadius: '5px',
                                border: '1px solid #415a77',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'flex-start'
                            }}>
                                <img
                                    src={certificate.image}
                                    alt={certificate.title}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        objectFit: 'contain',
                                        display: 'block'
                                    }}
                                />
                            </div>
                        </div>
                    </motion.div>
                ))}
            </div>

            <div className="d-flex justify-content-center mt-4">
                {certificates.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentIndex(index)}
                        className="mx-1 p-0 border-0 bg-transparent"
                        style={{
                            width: '12px',
                            height: '12px',
                            borderRadius: '50%',
                            background: index === currentIndex ? '#778da9' : '#415a77',
                            cursor: 'pointer'
                        }}
                        aria-label={`View certificate ${index + 1}`}
                    />
                ))}
            </div>
        </Container>
    );
};

export default Certificates;